import { withStyles, makeStyles } from '@material-ui/core/styles'
import { AddCircle, Delete } from '@material-ui/icons'

const styleConfig = {
  root: {
    color: '#7747b2',
    cursor: 'pointer',
    marginTop: '.3rem'
  }
}

export default makeStyles({
  row: {
    display: 'flex',
    padding: '.2rem',
    justifyContent: 'center'
  },
  item: {
    display: 'flex',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap'
  },
  learning: {
    color: '#1C9CDE',
    cursor: 'pointer',
    fontSize: '24px',
    padding: '.2rem',
    display: 'flex',
    flex: 1,
    borderRadius: '.2rem',
    '&:hover': {
      backgroundColor: 'rgba(166, 166, 166, 0.2)'
    }
  },
  value: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    flexDirection: 'row'
  },
  hide: {
    visibility: 'hidden'
  }
})

export const DeleteIcon = withStyles(styleConfig)(Delete)

export const AddCircleIcon = withStyles(styleConfig)(AddCircle)
